export default __webpack_public_path__ + "static/media/1.124ff40e.png";